import React, { useEffect, useState } from "react";
import Countdown from "../components/Countdown";
import "./Homepage.css";
import Carasolue from "../assets/up_1.png";
import Carasolue2 from "../assets/up_2.png";
import Carasolue3 from "../assets/up_3.png";
import CarouselHorizontal from "../assets/side_1.png";
import CarouselHorizontal2 from "../assets/side_2.png";

function Homepage() {
  const verticalImages = [Carasolue, Carasolue2, Carasolue3, Carasolue, Carasolue2, Carasolue3];
  const horizontalImages = [CarouselHorizontal, CarouselHorizontal2, CarouselHorizontal, CarouselHorizontal2];

  const [images, setImages] = useState(verticalImages);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true); // trigger fade-in once
    document.body.classList.add("homepage-no-scroll");

    const handleResize = () => {
      const isPortrait = window.innerHeight > window.innerWidth;
      setImages(isPortrait ? horizontalImages : verticalImages);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
      document.body.classList.remove("homepage-no-scroll");
    };
  }, []);
  return (
    <div className={`homepage-page bg-wrapper fade-in ${mounted ? "visible" : ""}`}>
      <div className="homepage-container">
        <div className="homepage-countdown">
          <Countdown />
        </div>

        <div class="scroll-container">
          <div class="scroll-track">
            {images.map((img, index) => (
              <img src={img} alt={`carousel-${index}`} />
            ))}
          </div>
        </div>

      </div>
    </div>
  );
}
export default Homepage;